<div class="page">
  <!-- top bar -->
  <section class="top-bar" [class.no-pointer]="loading && false">
    <!-- search left -->
    <div class="search-wrap">
      <div class="d-flex align-items-center">
        <div class="search-bar-wrap">
          <!-- search bar -->
          <app-field-text
            [model]="SEARCH.term"
            (modelChange)="SEARCH.term = $event"
            (enter)="search(undefined, undefined, 'enter')"
            [placeholder]="'projects_search_placeholder' | translate">
          </app-field-text>
        </div>
      </div>
      <div class="search-sub-wrap d-flex">
        <div class="d-flex align-items-start">
          @if (SEARCHED?.length) {
            <div class="tags">
              @for (tag of SEARCHED; track tag) {
                <div class="tag d-inline-flex align-items-center">
                  <span><span class="title">{{tag.title}}: </span><span class="value">{{tag.value}}</span></span>
                  <i class="im-icon im-icon-close-round-filled" (click)="SearchService.removeTag(tag.key, SEARCH, search)"></i>
                </div>
              }
            </div>
          }
          <!-- reset search button -->
          @if (SEARCHED?.length) {
            <button (click)="search(true)" class="button-link underline">{{'misc_reset_search' | translate}}</button>
          }
        </div>
      </div>
    </div>
    <!-- profile right -->
    <div class="profile-wrap d-flex align-items-center">
      <app-profile-section></app-profile-section>
    </div>
  </section>
  <!-- end top bar -->

  <!-- title -->
  <div class="d-flex justify-content-between">
    <h1 class="">{{'projects_title' | translate}} @if (ready) {
      <span [class.saving]="loading" class="saving--pre">({{totalRows}})</span>
    }</h1>
    <app-button classes="primary-default" icon="plus-round" text="{{'projects_add_button' | translate}}" [disabled]="false" [submitting]="false" (emitClick)="openCreateUpdateModal()"></app-button>
  </div>


  <!-- table -->
  <div class="table-wrap">
    <app-table
      [heads]="heads"
      [data]="items"
      [sort]="SORT"
      [RPP]="RPP"
      [startRow]="startRow"
      [totalRows]="totalRows"
      [loading]="loading"
      [ready]="ready"
      [timeout]="0"
      [selected]=""
      [emptyState]="'projects_emptystate' | translate"
      (sortChange)="clickSort($event.code, $event.dir)"
      (clickAction)="actionClick($event.item, $event.action)"
      (startRowChange)="changeStartRow($event)"
    ></app-table>
  </div>
</div>